import  { useEffect, useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLeftRight } from '@fortawesome/free-solid-svg-icons';
import '../../styles/before-after.css';

const BeforeAfterSlider = ({ beforeImage, afterImage }) => {
    const [sliderPos, setSliderPos] = useState(50);
    const [leftSlide, setLeftSlide] = useState(50);

    const handleSliderChange = (e) => {
        setSliderPos(e.target.value);
    };

   

    return (
        <div className="slider-container">
            {/* After Image (Background) */}
            <div
                className="image-after"
                style={{
                  backgroundImage: `url(${afterImage})`,
                }}
            >
            </div>

            {/* Before Image (Foreground/Clipped) */}
            
            <div
                className="image-before"
                style={{
                    backgroundImage: `url(${beforeImage})`,
                    width: `${sliderPos}%`
                }}
            >
            </div>

            {/* The Actual Slider Input */}
            <input
                type="range"
                min="0"
                max="100"
                value={sliderPos}
                onChange={handleSliderChange}
                className="slider-input"
            />

            {/* Visual Slider Line/Handle */}
            <div className="slider-line" style={{ left: `${sliderPos}%` }}>
                <div className="slider-handle flx-rw c-al c-jt" >
                    <FontAwesomeIcon icon={faLeftRight} />
                </div>
            </div>
        </div>
    );
};

export default BeforeAfterSlider;
